import { Entry } from '../Entry'

export function Entry20250521() {
  return (
    <Entry title="2025 May 21 - v3.10.10">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/17800/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
